
export default {
  SET_MANNING_VESSEL_CATEGORY_LIST(state, data) {
    state.manningVesselCategoryList = data;
  },
  SET_COUNTRY_CODE_LIST(state, data) {
    state.countryCodeList = data;
  },
}
